import { getCurrentQuarterRange } from '../../utils/time.ts'
import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store.ts'

interface DashboardInputState {
  dateRange: [string | null, string | null]
  showLiquidatedIdeas: boolean
}

export const dashboardInputSlice = createSlice({
  name: 'dashboardInput',
  initialState: {
    dateRange: getCurrentQuarterRange() as [string, string],
    showLiquidatedIdeas: false,
  } as DashboardInputState,
  reducers: {
    setDashboardInputDateRange: (state, action) => {
      state.dateRange = [
        action.payload?.[0] ? action.payload[0] : null,
        action.payload?.[1] ? action.payload[1] : null,
      ]
    },
    setDashboardShowLiquidatedIdeas: (state, action) => {
      state.showLiquidatedIdeas = action.payload
    },
  },
})

export const selectDashboardInput = (state: RootState) => state.dashboardInput

export const { setDashboardInputDateRange, setDashboardShowLiquidatedIdeas } =
  dashboardInputSlice.actions
